// @ts-nocheck
import React from "react";
import { Box, Typography, withStyles, createStyles } from "@material-ui/core";
import Fade from "@material-ui/core/Fade";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { surveyStyles, aboutUsStyle } from "./surveyStyles";
import QuestionCard from "./layout/QuestionCard.web";
import StepFooter from "./layout/StepFooter.web";
import FirmQuestions from "./layout/FirmQuestions.web";
import OptionToggle from "./layout/OptionToggle.web";
import { MagicLinkSelectField } from "./layout/FormFields.web";
import { magicLinkFormOverrides } from "./layout/formStyleOverrides";

const FILING_STATUSES = [
  "Single",
  "Head of household",
  "Married filing Single",
  "Married filing joint",
  "Not Sure/Need Recommendation",
].map((status) => ({ value: status, label: status }));

// "1" maps to 0 on purpose: pricing charges per additional state/country.
const LOCATION_COUNT_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((count) =>
  count === 1
    ? { value: 0, label: "1", disabled: true }
    : { value: count, label: String(count) }
);

const STATEMENTS = [
  {
    key: "isRealStateBusinessOutSideResidense",
    name: "Own real estate outside of primary residence",
  },
  { key: "isTradeOnMonthlyBasis", name: "Actively trade investments" },
  { key: "isTradeCrypto", name: "Own or trade cryptocurrency" },
  {
    key: "isOwnerShipInAnotherBusiness",
    name: "Partner/shareholder in another business",
  },
  {
    key: "isIncomeInAnotherStateOrCountary",
    name: "Earn income in multiple countries",
  },
  { key: "isActiveIssueWithIRS", name: "Have an active IRS issue" },
  { key: "isAllIncomeinOneState", name: "All income earned in one state" },
];

const TaxFillingSchema = Yup.object().shape({
  taxFillingStatus: Yup.string().required("This field is required"),
  isRealStateBusinessOutSideResidense: Yup.string().required(
    "This field is required"
  ),
  isTradeOnMonthlyBasis: Yup.string().required("This field is required"),
  isTradeCrypto: Yup.string().required("This field is required"),
  isOwnerShipInAnotherBusiness: Yup.string().required("This field is required"),
  isIncomeInAnotherStateOrCountary: Yup.string().required(
    "This field is required"
  ),
  isActiveIssueWithIRS: Yup.string().required("This field is required"),
  isAllIncomeinOneState: Yup.string().required("This field is required"),
  noOfStateIncomeEarnIn: Yup.string().required("This field is required"),
  no_of_countries_earn: Yup.string().required("This field is required"),
});
export const TaxFillingComponent = (props) => {
  const { classes, titleMessage, gotoNextStep } = props;
  const initialStatements = STATEMENTS.reduce(
    (values, { key }) => ({ ...values, [key]: props[key] || "false" }),
    {}
  );

  return (
    <Fade timeout={3000} in={true}>
      <Formik
        initialValues={{
          taxFillingStatus: props.taxFillingStatus || "Single",
          ...initialStatements,
          noOfStateIncomeEarnIn: props.noOfStateIncomeEarnIn || 0,
          no_of_countries_earn: props.no_of_countries_earn || 0,
        }}
        validationSchema={TaxFillingSchema}
        validateOnMount
        onSubmit={gotoNextStep}
      >
        {(formikProps) => {
          const { values, setFieldValue, isValid, errors, touched } = formikProps;
          const setValue = (name, value) => {
            props.setValueByDynamicName(name, value);
            setFieldValue(name, value);
          };
          const setStatement = (key) => (checked) => {
            setValue(key, checked ? "true" : "false");
            if (key === "isAllIncomeinOneState") {
              setValue("noOfStateIncomeEarnIn", checked ? 0 : 2);
            }
            if (key === "isIncomeInAnotherStateOrCountary") {
              setValue("no_of_countries_earn", checked ? 2 : 0);
            }
          };
          const handleSelect = (event) =>
            setValue(event.target.name, event.target.value);
          const goBack = () => {
            setValue("taxFillingStatus", "Single");
            STATEMENTS.forEach(({ key }) => setValue(key, ""));
            setValue("noOfStateIncomeEarnIn", 1);
            setValue("no_of_countries_earn", 1);
            props.gotoBackStep();
          };
          return (
            <Form autoComplete="off" noValidate>
              <QuestionCard title={titleMessage}>
                <Box className={classes.statusField}>
                  <MagicLinkSelectField
                    label="What is your filing status?"
                    name="taxFillingStatus"
                    id="taxFillingStatus"
                    value={values.taxFillingStatus}
                    options={FILING_STATUSES}
                    onChange={handleSelect}
                    error={
                      touched.taxFillingStatus && errors.taxFillingStatus
                        ? errors.taxFillingStatus
                        : ""
                    }
                  />
                </Box>
                <Typography className={classes.fieldPageSubHeading}>
                  Select all that apply
                </Typography>
                {STATEMENTS.map(({ key, name }) => (
                  <OptionToggle
                    key={key}
                    inputId={key}
                    label={name}
                    checked={values[key] === "true"}
                    onChange={setStatement(key)}
                  />
                ))}
                <Box className={classes.locationFields}>
                  <MagicLinkSelectField
                    label="Number of states you earn income in"
                    name="noOfStateIncomeEarnIn"
                    id="noOfStateIncomeEarnIn"
                    disabled={values.isAllIncomeinOneState === "true"}
                    value={values.noOfStateIncomeEarnIn}
                    options={LOCATION_COUNT_OPTIONS}
                    onChange={handleSelect}
                  />
                  <MagicLinkSelectField
                    label="Number of countries you earn income in"
                    name="no_of_countries_earn"
                    id="no_of_countries_earn"
                    disabled={values.isIncomeInAnotherStateOrCountary !== "true"}
                    value={values.no_of_countries_earn}
                    options={LOCATION_COUNT_OPTIONS}
                    onChange={handleSelect}
                  />
                </Box>
              </QuestionCard>
              <FirmQuestions
                screen="tax_situation"
                taxPayerType={props.taxPayerType}
                questions={props.firmQuestions}
                answers={props.firmAnswers}
                onChange={props.setFirmAnswer}
              />
              <StepFooter
                onBack={goBack}
                backId="taxFillingBackButton"
                nextType="submit"
                nextDisabled={!isValid}
              />
            </Form>
          );
        }}
      </Formik>
    </Fade>
  );
};
export default withStyles((theme) =>
  createStyles({
    ...surveyStyles(theme),
    ...aboutUsStyle(theme),
    ...magicLinkFormOverrides(theme),
    statusField: {
      maxWidth: 240,
      paddingBottom: 12,
    },
    locationFields: {
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      gap: 32,
      paddingTop: 20,
      [theme.breakpoints.down("xs")]: {
        gridTemplateColumns: "minmax(0, 1fr)",
        gap: 16,
      },
    },
  })
)(TaxFillingComponent);
